/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TrainingNoteVisibility } from './TrainingNoteVisibility';
import {
    TrainingNoteVisibilityFromJSON,
    TrainingNoteVisibilityFromJSONTyped,
    TrainingNoteVisibilityToJSON,
    TrainingNoteVisibilityToJSONTyped,
} from './TrainingNoteVisibility';
import type { TrainingNoteType } from './TrainingNoteType';
import {
    TrainingNoteTypeFromJSON,
    TrainingNoteTypeFromJSONTyped,
    TrainingNoteTypeToJSON,
    TrainingNoteTypeToJSONTyped,
} from './TrainingNoteType';

/**
 * 
 * @export
 * @interface TrainingNote
 */
export interface TrainingNote {
    /**
     * 
     * @type {string}
     * @memberof TrainingNote
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof TrainingNote
     */
    trainingId?: string;
    /**
     * 
     * @type {string}
     * @memberof TrainingNote
     */
    sessionId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrainingNote
     */
    playerId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrainingNote
     */
    playerName?: string | null;
    /**
     * 
     * @type {TrainingNoteVisibility}
     * @memberof TrainingNote
     */
    visibility?: TrainingNoteVisibility;
    /**
     * 
     * @type {TrainingNoteType}
     * @memberof TrainingNote
     */
    noteType?: TrainingNoteType;
    /**
     * 
     * @type {string}
     * @memberof TrainingNote
     */
    title?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrainingNote
     */
    body?: string;
    /**
     * 
     * @type {string}
     * @memberof TrainingNote
     */
    relatedMatchId?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof TrainingNote
     */
    eventDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof TrainingNote
     */
    createdBy?: string;
    /**
     * 
     * @type {Date}
     * @memberof TrainingNote
     */
    createdAt?: Date;
}



/**
 * Check if a given object implements the TrainingNote interface.
 */
export function instanceOfTrainingNote(value: object): value is TrainingNote {
    return true;
}

export function TrainingNoteFromJSON(json: any): TrainingNote {
    return TrainingNoteFromJSONTyped(json, false);
}

export function TrainingNoteFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrainingNote {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'trainingId': json['trainingId'] == null ? undefined : json['trainingId'],
        'sessionId': json['sessionId'] == null ? undefined : json['sessionId'],
        'playerId': json['playerId'] == null ? undefined : json['playerId'],
        'playerName': json['playerName'] == null ? undefined : json['playerName'],
        'visibility': json['visibility'] == null ? undefined : TrainingNoteVisibilityFromJSON(json['visibility']),
        'noteType': json['noteType'] == null ? undefined : TrainingNoteTypeFromJSON(json['noteType']),
        'title': json['title'] == null ? undefined : json['title'],
        'body': json['body'] == null ? undefined : json['body'],
        'relatedMatchId': json['relatedMatchId'] == null ? undefined : json['relatedMatchId'],
        'eventDate': json['eventDate'] == null ? undefined : (new Date(json['eventDate'])),
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
    };
}

export function TrainingNoteToJSON(json: any): TrainingNote {
    return TrainingNoteToJSONTyped(json, false);
}

export function TrainingNoteToJSONTyped(value?: TrainingNote | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'trainingId': value['trainingId'],
        'sessionId': value['sessionId'],
        'playerId': value['playerId'],
        'playerName': value['playerName'],
        'visibility': TrainingNoteVisibilityToJSON(value['visibility']),
        'noteType': TrainingNoteTypeToJSON(value['noteType']),
        'title': value['title'],
        'body': value['body'],
        'relatedMatchId': value['relatedMatchId'],
        'eventDate': value['eventDate'] == null ? value['eventDate'] : value['eventDate'].toISOString().substring(0,10),
        'createdBy': value['createdBy'],
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
    };
}

